// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".l-message[data-v-6582795f]{font-size:16px!important;font-weight:700;margin:18px 0;text-align:center}.l-message.m-error[data-v-6582795f]{color:red}.l-message.m-success[data-v-6582795f]{color:#10a386}@media screen and (max-width:767px){.l-message[data-v-6582795f]{margin:15px 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
